import { Link } from 'react-router-dom';
import { contact } from '../data/site';

const ContactBand = () => (
  <section className="section">
    <div className="container contact-band">
      <div>
        <h2>Looking for a supplier for your hospital or diagnostic centre?</h2>
        <p>Speak to our team about products, availability and service.</p>
      </div>
      <div className="button-row">
        <Link to="/contact" className="button button--primary">Contact us</Link>
        <a href={contact.phoneLink} className="button button--outline">{contact.phone}</a>
      </div>
    </div>
  </section>
);

export default ContactBand;
